import { useReactiveVar } from '@apollo/client';
import { EuiFormLabel } from '@elastic/eui';
import { priceInEUR } from 'cache';
import { RangeFilter } from 'components/RangeFilter/RangeFilter';
import { pricesOptions } from 'enums/G';
import { useIntl } from 'react-intl';
import { getOptions } from 'utils';

import * as S from './FiltersSidebar.styles';

export const PriceInEURFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const options = useReactiveVar(priceInEUR);

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.priceInEUR.label' })}</EuiFormLabel>
      <RangeFilter
        values={options as { min: string; max: string }}
        onChange={priceInEUR}
        data={getOptions(pricesOptions)}
      />
    </S.SidebarFilterWrapper>
  );
};
